import { Inject, Injectable } from '@angular/core';
import { CommonFireStoreDao, FetchOptions, QueryParam } from '../dao/CommonFireStoreDao.dao';
import { FIREBASE_APP } from '../injections/firebase-app';
import { FirebaseApp } from 'firebase/app';
import { ToastrService } from 'ngx-toastr';
import {
  AGENCIES_COLLECTION_NAME,
  AgencyDocumentCollections,
  AgencyMedia,
  AgencyMediaKeys,
} from '@ag-common-lib/public-api';

@Injectable({
  providedIn: 'root',
})
export class AgencyMediaService {
  readonly fsDao: CommonFireStoreDao<AgencyMedia>;
  private readonly agencyCollectionPath = AGENCIES_COLLECTION_NAME;
  private readonly mediaCollectionPath = AgencyDocumentCollections.media;

  constructor(
    @Inject(FIREBASE_APP) fireBaseApp: FirebaseApp,
    private toastrService: ToastrService,
  ) {
    this.fsDao = new CommonFireStoreDao<AgencyMedia>(fireBaseApp, null, null);
  }

  getList(agencyId: string, qp: QueryParam[] = [], fetchOptions?: FetchOptions) {
    const table = this.getCollectionPath(agencyId);

    return this.fsDao.getList(table, qp, fetchOptions);
  }

  async create(agencyId: string, data: AgencyMedia, silent = false): Promise<void | AgencyMedia> {
    const table = this.getCollectionPath(agencyId);
    const media = await this.fsDao
      .create(Object.assign(data, { [AgencyMediaKeys.agencyDbId]: agencyId }), table)
      .catch(e => {
        console.log('e', e);
      });

    !silent && this.toastrService.success('Agency Media Successfully Created!');

    return media;
  }

  async update(
    agencyId: string,
    documentId: any,
    updates: Partial<AgencyMedia>,
    silent = false,
  ): Promise<void | AgencyMedia> {
    const table = this.getCollectionPath(agencyId);

    const media = await this.fsDao.updateFields(updates, documentId, table).catch(e => {
      // TODO add error toast
      console.log('e', e);
      throw new Error(e);
    });

    !silent && this.toastrService.success('Agency Media Successfully Updated!');

    return media;
  }

  delete(agencyId: string, documentId: any, silent = false): Promise<void> {
    const table = this.getCollectionPath(agencyId);

    return this.fsDao.delete(documentId, table).then(response => {
      if (!silent) {
        this.toastrService.success('Agency Media Removed!');
      }
      return response;
    });
  }

  private getCollectionPath(agencyId: string): string {
    return [this.agencyCollectionPath, agencyId, this.mediaCollectionPath].join('/');
  }
}
